'use client'

import earthPic from '@/assets/images/earth.png';
import { Link } from "react-router-dom";
import React from "react";
export default function SignIn() {

  // const gotoPolarisInvest = ()=>{
  //   window.open('https://invest.polarisagi.com/', '_blank');
  // }

  return (
      <div>
        {/* investment区域 */}
        <section
          className="relative top-0 bg-white"
          style={{height: '772px', overflow: 'hidden'}}
        >
          {/* 背景图片 - 右侧50%宽度 */}
          <div className="absolute top-0 right-0 w-3/5 h-full z-0" style={{transform: " scale(1.5) translateX(140px) rotateX(180deg) rotate(-50deg)"}}>
            <img
              src={earthPic}
              alt="Investment Background"
              className="object-cover"
            />
            <div className="absolute w-full h-full top-0 left-0  bg-gradient-to-tl from-white/0 to-white/100"></div>
          </div>

          <div className="w-[775px] relative top-[224px] inline-flex flex-col justify-start items-start gap-5">
            <div className="self-stretch justify-start text-[#414141] text-7xl font-medium font-['Figtree'] leading-[83.60px] -tracking-wide">Sign in to Polaris</div>
            <div className="justify-start">
              <span className="text-[#676767] text-base font-normal font-['Inter'] leading-tight -tracking-wide">Not a member yet? </span>
              <span className="text-[#6E66E1] text-base font-normal font-['Inter'] underline leading-tight cursor-pointer">Request access now</span>
            </div>
            <div className="w-96 p-5 box-content bg-stone-50 rounded-xl outline outline-1 outline-offset-[-1px] flex flex-col justify-center items-center gap-6">
              <div className="self-stretch flex flex-col justify-center items-center gap-2.5">
                <div style={{border: '1px solid rgba(60, 59, 59, 0.2)'}} className="self-stretch h-10 px-4 py-1 bg-white rounded-[100px] inline-flex justify-start items-center focus-within:border-opacity-20">
                  <div className="w-full h-full flex justify-start items-start overflow-hidden">
                    <input className="w-full h-full justify-center bg-white text-[#3C3B3B] text-xs font-normal font-['Figtree'] leading-relaxed outline-none focus:outline-none focus:ring-0" placeholder="Email"/>
                  </div>
                </div>
                <div style={{border: '1px solid rgba(60, 59, 59, 0.2)'}} className="self-stretch h-10 px-4 py-1 bg-white rounded-[100px] inline-flex justify-start items-center focus-within:border-opacity-20">
                  <div className="w-full h-full flex justify-start items-start overflow-hidden">
                    <input className="w-full h-full justify-center bg-white text-[#3C3B3B] text-neutral-700/80 text-xs font-normal font-['Figtree'] leading-relaxed outline-none focus:outline-none focus:ring-0" placeholder="Password" type="password"/>
                  </div>
                </div>
              </div>
              <div className="self-stretch h-10 p-4 bg-[#6E66E1] rounded-[100px] inline-flex justify-center items-center transition-all duration-300 ease-in-out group cursor-pointer">
                <div className="justify-start text-white text-sm font-bold font-['Figtree'] -tracking-wide">Sign In</div>
                <svg className="ml-1 transition-all duration-300 ease-in-out transform  group-hover:translate-x-1" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.822291 10.9291L9.9982 1.75314L2.13314 1.75314L2.06572 0.696975L11.8034 0.696975L11.8034 10.4347L10.7473 10.3673L10.7473 2.50219L1.57134 11.6781L0.822291 10.9291Z" fill="white"/>
                </svg>
              </div>
              <div className="self-stretch text-center justify-start text-[#676767] text-xs font-normal font-['Inter'] leading-3">Forgot Password</div>
            </div>
            <div className="w-96 justify-start leading-none">
              <span className="text-[#676767] text-xs font-normal font-['Figtree'] leading-none">© 2025 Polaris. All Rights Reserved. By continuing, you agree to Polaris’</span>
              <span className="text-[#676767] text-xs font-normal font-['Figtree'] leading-none cursor-pointer"> <Link to={`/terms-of-use`} target={`_blank`} className={`underline underline-offset-2`}>Terms of Use</Link></span>
              <span className="text-[#676767] text-xs font-normal font-['Figtree'] leading-none"> and </span>
              <span className="text-[#676767] text-xs font-normal font-['Figtree'] leading-none cursor-pointer"><Link to={`/privacy-policy`} target={`_blank`} className={`underline underline-offset-2`}>Privacy Policy</Link>.</span>
            </div>
          </div>
        </section>
      </div>
  );
}
